import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./AssignAccountVipStatusForm";
import ConfirmForm from "../../components/forms/ConfirmForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelAssignAccountVipStatus} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "pricelistVersion");

  return errors.toJS();
}


class AssignAccountVipStatusFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("accountId", this.props.accountId);
    return this.props.assignAccountVipStatus(updatedValues.toJS())
      .then((response) => {
        if (response.data.assignAccountVipStatus.errors.length <= 0) {
          this.props.cancelAssignAccountVipStatus();
        } else {
          let errors = createValidationErrors(response.data.assignAccountVipStatus.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelAssignAccountVipStatus();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let info = fromJS(data.shopActivePricelistsForAccount);
    let account = fromJS(data.account);
    let versions = info.get("versions").map((version) => {
      if (version === info.get("current")) {
        return Map({version: version, label: `${version} (current shop version)`});
      } 
      return Map({version: version, label: version});
    });
    let initialValues = Map({
      pricelistVersion: info.get("current")
    });

    if (account.get("vip") === true) {
      return (
        <ConfirmForm
          message="This account is already a VIP account."
          onSubmit={this.handleCancel.bind(this)}
          showCancel={false}
          errors={this.state.errors}
          />
      )
    }

    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        versions={versions}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const ASSIGN_ACCOUNT_VIP_STATUS = gql`
  mutation assignAccountVipStatus($data: AssignAccountVipStatusInput!) {
    assignAccountVipStatus(input: $data) {
      errors { key message }
    }
  }
`;

const ACTIVE_SHOP_PRICELISTS_FOR_ACCOUNT = gql`
  query shopActivePricelistsForAccount($accountId:ID!) {
    shopActivePricelistsForAccount(accountId: $accountId) {
      shopId,
      current,
      versions
    }
    account(accountId: $accountId) {
      vip
    }
  }
`

const withQueries = compose(
  graphql(ACTIVE_SHOP_PRICELISTS_FOR_ACCOUNT, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.accountId
      }
    })
  }),
  graphql(ASSIGN_ACCOUNT_VIP_STATUS, {
    props: ({ mutate }) => ({
      assignAccountVipStatus: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelAssignAccountVipStatus})(withQueries(AssignAccountVipStatusFormContainer));